/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')

export interface PrivacyWordState {
  privacyWords: Array<types.PrivacyWord>
  [key: string]: any;
}

const PrivacyWord = defineModule({
  state: (): PrivacyWordState => {
    return {
      privacyWords: []
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async add(context, payload: types.PrivacyWord): Promise<boolean> {
      const { rootState } = moduleActionContext(context, PrivacyWord)
      if (payload.privacyWordId == '') {
        const retval = await Lib.Ajax.getHandleError<types.DataResponse<boolean>>('/api/privacyword/add' + (payload.privacyWordId == '' ? '' : '/' + payload.privacyWordId), "プライバシーワードの追加に失敗しました。", { targetWord: payload.targetWord, alternateWord: payload.alternateWord }, rootState.Login.accessToken)
        var groups = retval.data.data
        return groups
      } else {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/privacyword/add' + (payload.privacyWordId == '' ? '' : '/' + payload.privacyWordId), "プライバシーワードの設定に失敗しました。", { targetWord: payload.targetWord, alternateWord: payload.alternateWord }, rootState.Login.accessToken)
        groups = retval.data.data
        return groups  
      }
    },
    async listAll(context): Promise<Array<types.PrivacyWord>> {
      const { rootState, commit } = moduleActionContext(context, PrivacyWord)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.PrivacyWord>>>('/api/privacyword/listall', "プライバシーワードの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      commit.SET_VALUE({name: 'privacyWords', value: list})
      return list
    },
  },
  namespaced: true
})

export default PrivacyWord